import styled from 'styled-components';

export const PanelContainer = styled.div<{ $isOpen: boolean }>`
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 40px;
    border: 1px solid rgba(224, 224, 224, 1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
    padding: 24px;
    width: 100%;
    height: 740px;
    overflow: hidden;
    transition: transform 300ms ease, opacity 300ms ease;
    margin-top: 16px;
    margin-bottom: 8px;

    @media (min-width: 1200px) {
        width: 740px;
    }

    @media (min-width: 1600px) {
        width: 450px;
        margin-top: 0;
        margin-bottom: 0;
        transform: translateX(${props => props.$isOpen ? '0' : '100%'});
        opacity: ${props => props.$isOpen ? '1' : '0'};
    }
`;

export const PanelHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    margin-bottom: 24px;
`;

export const SourceSection = styled.div`
    margin-bottom: 16px;
`;

export const SectionDivider = styled.div`
    height: 1px;
    background-color: rgba(224, 224, 224, 1);
    margin: 16px 0;
`;

export const SourceHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding: 8px 0;
`;

export const SourceName = styled.h4`
    font-size: 16px;
    font-weight: 600;
    color: rgba(38, 38, 38, 1);
    margin: 0;
`;

export const SourceActions = styled.div`
    display: flex;
    gap: 8px;
`;

export const FilesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 12px;
    margin-bottom: 16px;
`;

export const ScrollableContent = styled.div<{ $isEmpty?: boolean }>`
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 8px;
    display: ${props => props.$isEmpty ? 'flex' : 'block'};
    align-items: ${props => props.$isEmpty ? 'center' : 'stretch'};
    justify-content: ${props => props.$isEmpty ? 'center' : 'flex-start'};

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: rgba(0, 0, 0, 0.05);
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 3px;

        &:hover {
            background: rgba(0, 0, 0, 0.3);
        }
    }
`;

export const EmptyState = styled.div`
    margin-bottom: 30px;
    padding: 16px;
    text-align: center;
    color: rgba(107, 114, 128, 1);
`;

export const EmptyStateText = styled.p`
    font-size: 14px;
    margin: 0;
`;
